<template lang="pug">
  .sidebar
    .sidebar__toolbar.admin-sidebar
      h2.sidebar__title {{ activeItem.title | translate }}
    .sidebar__menu-wrapper
      v-card.sidebar__menu
        template(v-for="item in flattenedItems")
          .sidebar__menu-item(
            :key="item.id"
            :class="{ 'sidebar__menu-item--active': isActive(item), 'sidebar__menu-item--disabled': item.disabled }"
            @click="onClick(item)")
            svg.sidebar__menu-item-icon
              use(:xlink:href="`/svg/sprite.svg?v=${Date.now()}#${item.icon}`")
            span {{ item.title | translate }}
</template>

<script>
export default {
  name: 'AdminSidebar',

  props: {
    items: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    flattenedItems () {
      const result = []

      this.items.forEach(item => {
        // Skip color-indication items completely
        if (item.path === 'color-indication') {
          return
        }

        // If item has submenu, add only subitems
        if (item.submenu && item.submenu.length > 0) {
          item.submenu.forEach(subitem => {
            // Also check subitems for color-indication
            if (subitem.path !== 'color-indication') {
              result.push(subitem)
            }
          })
        } else {
          // Add regular items (without submenu), but exclude mixer-db and blanks
          if (item.title !== 'base.blanks' && item.path !== 'mixer-db') {
            result.push(item)
          }
        }
      })

      return result
    },

    activeItem () {
      return this.flattenedItems.find(item => this.isActive(item)) || this.flattenedItems[0] || {}
    },

    clientId () {
      return this.$store.getters.clientId
    }
  },

  methods: {
    isActive (item) {
      if (!item.path) return false
      const path = item.path.split('?')[0]
      if (path.startsWith('../')) {
        return this.$route.path.includes(path.substring(3))
      }
      return this.$route.path.includes(path)
    },

    onClick (item) {
      if (item.disabled) return

      if (item.path === 'mixer-db') {
        this.$router.push({ path: `/app/${item.path}` })
      } else if (item.path) {
        let targetPath
        if (this.isAdmin) {
          targetPath = `/app/clients/${this.clientId}/admin/${item.path}`
        } else {
          targetPath = `/app/admin/${item.path}`
        }
        this.$router.push({ path: targetPath })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {

  &__menu-item {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
    transition: background 0.3s;
    border-radius: 8px;

    &:hover {
      background: #EEEEEE;
    }

    &--active {
      background: #DDF2E3;
    }

    &--disabled {
      cursor: not-allowed;
      opacity: 0.5;
      pointer-events: none;
    }
  }

  &__menu-item-icon {
    height: 26px;
    width: 26px;
    margin-right: 16px;
    flex-shrink: 0;
  }
}
</style>